<template>
  <div>
    <el-card>
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">账户充值</span>
      </div>
      <el-button type="primary" size="small" style="margin: 0 0 10px 20px"
                 icon="el-icon-plus" @click="handleInvistAdd('立即充值')">立即充值
      </el-button>

      <el-table :data="tableData"
                ref="table"
                border default-expand-all stripe style="width: 100%;margin-bottom: 20px;"
                :max-height="tableHeight"
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}">
        <el-table-column prop="investMoneyNumber" label="充值编号"/>
        <el-table-column prop="createTime" label="提交时间"/>
        <el-table-column prop="payAccountNumber" label="付款账号"/>
        <el-table-column prop="payMoney" label="充值金额"/>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope" >
            <span style="text-align: center">{{scope.row.statusStr}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remarks" label="备注"/>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="text"
                       @click="handleShowDetail(scope.$index, scope.row,'查看充值单')">查看充值单
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          :page-sizes="[20, 50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.pageNum"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          @size-change="handlePageSizeChange"
          @current-change="handlePageNumChange"
          background
          style="float: right;margin-bottom: 10px">
      </el-pagination>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
      <el-dialog width="45%"
                 title="充值注意事项："
                 :before-close="innerDialogClose"
                 :visible.sync="innerdialogDetailFormVisible"
                 append-to-body>
        <el-row :gutter="20">
          <el-col :span="24">
            <span style="color: red;margin: 5%;">请按提交充值页面中的账号转账，否则无法到账， 后果自负！</span>
          </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer">
          <el-button @click="" size="mini" type="primary">{{countDoneValue}}</el-button>
        </div>
      </el-dialog>
      <el-form ref="dialogForm" :model="dialogForm" label-width="260px">
        <el-row :gutter="5">
          <el-col :span="24">
            <el-form-item label="收款方式">
              <span>{{ reciverBackInfo.backName }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="24">
            <el-form-item label="收款账户">
              <span>{{ reciverBackInfo.backCardNum }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5" >
          <el-col :span="24">
            <el-form-item label="收款户名" >
              <span>{{ reciverBackInfo.backCardName }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5" v-if="reciverBackInfo.backOpenAdress != null">
          <el-col :span="24">
            <el-form-item label="收款开户银行">
              <span>{{ reciverBackInfo.backName }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5" v-if="reciverBackInfo.isMobilePay">
          <el-col :span="24">
            <el-form-item label="收款二维码">
              <img :src="reciverBackInfo.reciveMoneyCodeUrl" class="qrcode">
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :span="24">
            <el-form-item label="请选择付款账号" prop="backName">
              <el-select v-model="dialogForm.payBackAccount" clearable placeholder="请选择支付宝">
                <el-option
                    v-for="item in backOptions"
                    :key="item.value"
                    :label="item.backCardName+' '+item.backCardNum"
                    :value="item.id"
                >
                </el-option>
              </el-select>
              <span class="el-icon-plus" style="margin-left: 2px;"><router-link to="/home/businbackcardm">添加支付信息</router-link></span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="充值金额" prop="investMoney">
              <el-input v-model="dialogForm.payMoney" placeholder="输入金额" style="width: 80%;"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col span="12">
            <el-form-item label="充值截图" prop="investPicter">
              <el-upload
                  class="avatar-uploader"
                  action="https://api.weiquanai.com/taskservice/file/upload"
                  :headers="myheader"
                  :show-file-list="false"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  :on-success="handleAvatarSuccess"
                  :on-remove="handleAvatarRemove">
                <img v-if="dialogForm.transferMoneyImageUrl" :src="dialogForm.transferMoneyImageUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="text-align: left; margin: 10px; margin-left: 25%;">
          <el-col :span="24">
            <el-row :gutter="20" >
              <el-col span="20">
                <span>充值提醒：</span>
              </el-col>
            </el-row>
            <el-row :gutter="20" >
              <el-col :span="20">
                <span>1.不能使用ATM转账</span>
              </el-col>
            </el-row>
            <el-row :gutter="20" >
              <el-col :span="20">
                <span>2.转账请不要备注信息</span>
              </el-col>
            </el-row>
            <el-row :gutter="20" >
              <el-col :span="20">
                <span>3.先转账再提交充值单，请提交充值截图便于快速审核</span>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col span="20">
                <span>4.提现和充值必须是同一张银行卡</span>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitDialogForm()" size="mini" type="primary">提交充值单</el-button>
        <el-button @click="handleCloseDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="dialogDetailTitle" :visible.sync="dialogDetailFormVisible">
      <el-form ref="dialogDetailForm" :model="dialogDetailForm" label-width="260px">
      <el-row :gutter="5">
        <el-col span="20">
          <el-form-item label="状态">
            <div>{{detail.status}}</div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col span="20">
          <el-form-item label="收款账户">
            <div>{{detail.receiveMoneyBack}}</div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col span="20">
          <el-form-item label="户名">
            <div>{{detail.receiveUserName}}</div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col span="20">
          <el-form-item label="开户银行">
            <div>{{detail.receiveBackName}}</div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col span="20">
          <el-form-item label="转账金额">
            <div>{{detail.transferMoney}}</div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col span="20">
          <el-form-item label="转账银行">
            <div>{{detail.transferBack}}</div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col span="20">
          <el-form-item label="银行卡号">
            <div>{{detail.transferBackNumber}}</div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col span="20">
          <el-form-item label="充值截图">
            <div class="demo-image__preview">
              <el-image
                  style="width: 100%; height: 100%"
                  :src="detail.transferMoneyImageUrl"
                  :preview-src-list="new Array(detail.transferMoneyImageUrl)">
              </el-image>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
        <el-row :gutter="5">
          <el-col span="20">
            <el-form-item label="备注">
              <div>{{detail.remarks}}</div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    <customer-service-component></customer-service-component>
  </div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD';
import {getAllB2cBackCard, getBackCardWithBusiness} from "../../api/b2cbusiness/b2c_backcardmanage";
import {addInvestMoney, getInvestMoney, getInvestMoneyDetail} from "../../api/b2cbusiness/b2c_investmoney";
import {getJwtToken, isStrEmpty} from "../../lib/utils";
import CustomerServiceComponent from "../../components/CustomerServiceComponent";
import MinxinScroll from "@/components/MinxinScroll";

export default {
  name: "ApplyInvestMoney",
  components:{CustomerServiceComponent,},
  mixins: [MixinCUD, MinxinScroll],
  data() {
    return {
      myheader: {
        JWTHeaderName: ""
      },
      tableData: [],
      queryForm: {
      },
      backOptions:[],
      dialogFormVisible: false,
      innerdialogDetailFormVisible:false,
      dialogTitle: "",
      dialogRefName: "dialogForm",
      dialogForm:{
      },
      countDoneValue: 5,
      dialogDetailFormVisible: false,
      dialogDetailTitle: "充值详情",
      detail:{
      },
      reciverBackInfo:{
      },
      tableHeight: 450,
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 320;
    //console.log(document.body.clientHeight, this.tableHeight)
  },
  mounted() {
    getAllB2cBackCard().then(res=>{
      if (res.success){
        console.log(res.data)
        this.backOptions = res.data;
      }
    });
    this.myheader.JWTHeaderName = getJwtToken();
    getBackCardWithBusiness({b2cUsersId:null, isPlateformAccount:true}).then(res=>{
      console.log(res.data)
      if (res.success){
        this.reciverBackInfo = res.data;
      }
    });

    this.getData();
  },
  activated() {
    getAllB2cBackCard().then(res=>{
      if (res.success){
        //console.log(res.data)
        this.backOptions = res.data;
      }
    });
  },
  methods:{
    innerDialogClose(done){
      if (this.innerdialogDetailFormVisible){
        return false;
      }else {
        return done(true);
      }
    },
    countDoneDialog(){
      this.countDoneValue = 5;
      let countTmp = this.countDoneValue;
      let t = setInterval(()=>{
        if (countTmp >  0){
          this.countDoneValue = --countTmp;
        }else{
          this.innerdialogDetailFormVisible = false;
          clearInterval(t);
        }
      }, 1000);
    },
    handleInvistAdd(dialogTitle){
      this.dialogFormVisible = true;
      this.dialogTitle = dialogTitle
      this.resetDialogForm()
      if (this.dialogFormVisible){
        let minus = 1;
        let i = setInterval(_=>{
          if (minus <= 0){
            this.innerdialogDetailFormVisible = true;
            this.countDoneDialog();
            clearInterval(i);
          }
          --minus;
        }, 100)
      }
    },
    handleShowDetail(index, row,dialogTitle){
      getInvestMoneyDetail(row.id).then(res=>{
        if (res.success){
          this.detail = res.data;
          this.dialogDetailFormVisible = true;
          this.dialogDetailTitle = dialogTitle;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    addData(){
      //console.log(this.dialogForm, this.reciverBackInfo)
      this.dialogForm = Object.assign(this.dialogForm, this.reciverBackInfo);
      //console.log(this.dialogForm)
      if (isStrEmpty(this.dialogForm.payBackAccount)){
        this.$message({message: "必须选择付款账户，如没有添加则点击旁边添加按钮", type: 'error'});
      }else{
        if (!isStrEmpty(this.dialogForm.transferMoneyImageUrl)){
          addInvestMoney(this.dialogForm).then(res=>{
            if (res.success){
              this.$message({message: res.data, type: 'success'});
              this.submitQueryForm();//新增之后，重新查询table
              this.handleCloseDialog();
            }
          }).catch(err => {
            this.$message({message: err.message, type: 'error'});
          });
        }else{
          this.$message({message: "必须上传支付截图", type: 'error'});
        }
      }
    },
    getData(){
      getInvestMoney(this.queryForm, this.pagination).then(res=>{
        if (res.success){
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      });
    },
    handleAvatarSuccess(res, file) {
      console.log(res, file);
      this.dialogForm.transferMoneyImageUrl = res.data;
      console.log(this.dialogForm.transferMoneyImageUrl)
      let self = this;
      self.$forceUpdate();
    },
    handlePageSizeChange(val){
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val){
      this.pagination.pageNum = val;
      this.submitQueryForm()
      //切换页面恢复到顶部
      this.scrollTop = 0
      this.saveScroll()
    },
  },
}
</script>

<style lang="scss" scoped>
.el-form {
  margin-top: 0px;
}

/deep/ .el-dialog__body{
  padding: 0;
}

/deep/ .el-form-item{
  margin-bottom: 5px;
}

.avatar-uploader {
  border: 1px dashed gray;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 220px;
}

.el-upload {
  border: 1px dashed gray;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 220px;
  height: 220px;
  line-height: 220px;
  text-align: center;
}

.avatar {
  width: 220px;
  height: 220px;
  display: block;
}


.qrcode {
  width: 14rem;
  height: 14rem;
  display: block;
}
</style>
